import * as React from 'react';

import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';

import SOVFiltersSectionHeader from '../section/SOVFiltersSectionHeader';

import { __t, applyTranslations } from 'utils/language';
import { mapItemsToCommon } from 'modules/insights/sov/utils/sov';

import './sov-filters-countries.scss';

import type { MixedSelectDropdownItem } from 'types';
import type { SOVReport } from 'modules/insights/sov/types';

applyTranslations(require('../sov-filters.i18n.json'));

type Props = {
  report: SOVReport,
  withErrorHighlight?: boolean,
  countries: Array<MixedSelectDropdownItem>,
  onCountriesChange: (countries: Array<string | undefined>) => void
};

const FILTERS_MSG_KEY = 'sov_filters';

class SOVFiltersCountries extends React.PureComponent<Props> {
  handleCountriesChange = (items: Array<MixedSelectDropdownItem>): void => {
    const { onCountriesChange } = this.props;
    const countryNames = items.filter(item => item.isSelected)
      .map(item => item.label);

    onCountriesChange(countryNames);
  };

  renderHeader(): React.ReactNode {
    return (
      <SOVFiltersSectionHeader
        msgKey="countries"
        tooltipKey="countries"
        isRequired
      />
    );
  }

  renderDropdown(): React.ReactNode {
    const { report, countries } = this.props;

    return (
      <MixedSelectDropdown
        withMulti
        withSelectAll
        withRemovable
        withSearchable
        withSortable
        name="countries"
        placeholder={__t(`${FILTERS_MSG_KEY}.placeholders.countries`)}
        items={mapItemsToCommon(countries, report.countries)}
        onItemsToggle={this.handleCountriesChange}
        onItemsToggleAll={this.handleCountriesChange}
        onItemsRemove={this.handleCountriesChange}
        onItemsRemoveAll={this.handleCountriesChange}
      />
    );
  }

  render(): React.ReactNode {
    const { report, withErrorHighlight } = this.props;
    const isInvalidCountriesList = !report.countries?.length;

    return (
      <div className="sov-filters-countries">
        {this.renderHeader()}
        {this.renderDropdown()}
        {withErrorHighlight && isInvalidCountriesList && (
          <div className="form-field__error">
            {__t(`${FILTERS_MSG_KEY}.errors.missed_countries`)}
          </div>
        )}
      </div>
    );
  }
}

export default SOVFiltersCountries;
